module.exports = __webpack_public_path__ + "static/img/case2-bg.b7cc3ab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case2-bg.webp
// module id = MXpm
// module chunks = 0